import {Component, OnDestroy} from '@angular/core';
import {AuthRedirectService, AuthRedirectStorageService} from '@spartacus/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {take} from 'rxjs/operators';
import {SessionStorageService, LoadingPageComponent} from '@dcp/configurator';

export const REDIRECT_URL_QUERY_KEY: string = 'dcpRedirectUrl';

@UntilDestroy()
@Component({
  selector: 'dcp-auth',
  styleUrls: ['./auth.component.scss'],
  templateUrl: './auth.component.html',
  imports: [LoadingPageComponent],
})
export class AuthComponent implements OnDestroy {
  constructor(
    protected authRedirectService: AuthRedirectService,
    protected authRedirectStorageService: AuthRedirectStorageService,
    private sessionStorageService: SessionStorageService,
  ) {
    this.authRedirectStorageService
      .getRedirectUrl()
      .pipe(untilDestroyed(this), take(1))
      .subscribe((redirectUrl) => {
        if (redirectUrl?.startsWith(location.pathname.replace(/^\//g, ''))) {
          redirectUrl = '';
          this.authRedirectStorageService.setRedirectUrl(redirectUrl);
        }
        this.handleDcpRedirectRules(redirectUrl);
      });
  }

  handleDcpRedirectRules(redirectUrl: string) {
    if (redirectUrl?.length) {
      this.sessionStorageService.setItem(REDIRECT_URL_QUERY_KEY, redirectUrl);
    } else if (this.sessionStorageService.getItem(REDIRECT_URL_QUERY_KEY)?.length) {
      this.authRedirectStorageService.setRedirectUrl(this.sessionStorageService.getItem(REDIRECT_URL_QUERY_KEY));
    }
    this.authRedirectService.redirect();
  }

  ngOnDestroy(): void {
    this.sessionStorageService.removeItem(REDIRECT_URL_QUERY_KEY);
  }
}
